import { Controller, Post, Body } from '@nestjs/common';
import { CommonResponse, DeheadingPeelingResponseModel } from '@gtpl/shared-models/masters';
import { DeheadingratesDTO } from './dto/deheading-rates.dto';
import { DeheadingRatesService } from './deheading-rates-service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Controller('deheading-rates')
export class DeheadingRatesController {
    constructor(
        private readonly deheadingRatesService: DeheadingRatesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler // Assuming you have this service for handling exceptions
    ) {}

    @Post('/saveDeheadingRatesInfo')
    async saveDeheadingRatesInfo(@Body() data: { data: DeheadingratesDTO[], user: string }): Promise<CommonResponse> {
        try {
            return this.deheadingRatesService.saveDeheadingRatesInfo(data);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAllDegeadingRatesData')
    async getAllDegeadingRatesData():Promise<CommonResponse>{
        try{
            return await this.deheadingRatesService.getAllDegeadingRatesData();
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
}
